exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 900px){.list.user-mentor .title-container{flex-direction:column;align-items:flex-start}.list.user-mentor .filter-container{align-items:flex-start}.filter-container{flex-direction:column;align-items:left}.filter-container .checkbox{margin-top:.7rem}.filter-container .c--multiselect{margin-top:1.2rem}.filter-container .expand-all{margin-top:1.2rem}}", ""]);

// exports
